import {Component} from '@angular/core';
import {AuthService} from '@service/auth.service';
import { Bind } from 'primeng/bind';
import { Toast } from 'primeng/toast';
import { AppLoaderComponent } from '../app-loader/app-loader.component';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { AppHeaderComponent } from '../app-header/app-header.component';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'aud-app-layout',
    templateUrl: './app-layout.component.html',
    styleUrls: ['./app-layout.component.scss'],
    imports: [Bind, Toast, AppLoaderComponent, ConfirmDialog, AppHeaderComponent, RouterOutlet, TranslateModule]
})
export class AppLayoutComponent {

    public constructor(
        private authService: AuthService,
    ) { }

    public logout() {
        this.authService.logout();
        window.location.reload();
    }
}
